export const enum menuItems {
  home = 'Home',
  exceptions = 'Exceptions',
  transactionRules = 'Transactions & Rules',
  businessAdministration = 'Business Administration',
  clientSetup = 'Client Setup',
  transactionReports = 'Transaction Reports',
  businessAdminLogs = 'Business Admin Logs',
  itSystemConfiguration = 'IT System Configuration',
}

export enum submenuItems {
  home = 'Home',
  exceptionProcessing = 'Quick Exception Processing',
  quickExceptionProcessing = 'Quick Exception Processing',
  adminDecisionProcessing = 'Admin Decision Processing',
  submitIssuedCheckFile = 'Submit Issued Check File',
  addNewIssuedCheck = 'Add New Issued Check',
  allTransactions = 'All Transactions',
  searchResult = 'All Transactions Results',
  voidChecks = 'Void Checks',
  achExceptionRules = 'ACH Exception Rules',
  checkVerification = 'Check Verification',
  bankUserSetup = 'Bank User Setup',
  securityTemplates = 'Security Templates',
  broadcastEmail = 'Broadcast Email',
  purgeTransactions = 'Purge Transactions',
  systemWideRules = 'System-Wide Rules',
  clientSetup = 'Client Setup',
  addClientSetup = 'Add Client Setup',
  editClientSetup = 'Edit Client Setup',
  viewClientSetup = 'View Client Setup',
  accountSetup = 'Account Setup',
  newAccount = 'Add Account',
  viewUsersForAccount = 'View Users For Account',
  editAccount = 'Edit Account',
  viewAccount = 'View Account',
  clientUserSetup = 'Client User Setup',
  fileMappingSetup = 'File Mapping Setup',
  payeeMatchParameters = 'Payee Match Parameters',
  addPayeeMatchParameters = 'Add Payee Match Parameters',
  editPayeeMatchParameters = 'Edit Payee Match Parameters',
  viewPayeeMatchParameters = 'View Payee Match Parameters',
  batchProcessing = 'Batch Processing',
  dataImportProcessing = 'Data Import Processing',
  fileMappingFormats = 'File Mapping Formats',
  sentEmailTexts = 'Sent Email/Texts',
  sentEmailTextsResults = 'Sent Email/Texts Results',
  auditTrailLog = 'Audit Trail Log',
  loginAccessReport = 'Login and Access Report',
  systemAudit = 'System Audit',
  transactionAudit = 'Transaction Audit',
  userAudit = 'User Audit',
  dailyChecksIssuedSummary = 'Daily Checks Issued Summary',
  issuedCheckProcessingLog = 'Check File Upload History',
  issuedCheckProcessingLogResults = 'Check File Upload History Results',
  exceptionItems = 'Exception Items',
  exceptionItemsSearchResult = 'Exception Items Results',
  viewExceptionItem = 'View Exception Items',
  exceptionItemAuditHistory = 'View Audit History',
  managementDashboard = 'Management Dashboard',
  reconciliationSummary = 'Reconciliation Summary',
  brandingSetup = 'Branding Setup',
  emailTextSetup = 'Email/Text Setup',
  exceptionCodes = 'Exception Codes',
  holidayDates = 'Holiday Dates',
  reasonCodes = 'Reason Codes',
  systemAction = 'System Action',
  systemClassification = 'System Classification',
  systemErrors = 'System Errors',
  systemSetup = 'System Setup',
  transactionCodes = 'Transaction Codes',
  addFileMapping = 'Add File Mapping',
  viewFileMapping = 'View File Mapping',
  editFileMapping = 'Edit File Mapping',
  userRoles = 'User Roles',
  viewUserRole = 'View User Role',
  addUserRole = 'Add User Role',
  editUserRole = 'Edit User Role',
  addClientUserSetup = 'Add Client User Setup',
  copyClientUserSetup = 'Copy Client User Setup',
  editClientUserSetup = 'Edit Client User Setup',
  copyBankUserSetup = 'Copy Bank User Setup',
  addBankUserSetup = 'Add Bank User Setup',
  copyFileMapping = 'Copy File Mapping',
  editBankUserSetup = 'Edit Bank User Setup',
  resultScreen = 'Check File Upload History Results',
  viewErrorDetail = 'View Error Details',
  achExceptionRule = 'ACH Exception Rule',
  achExceptionRulesAdd = 'Add ACH Exception Rule',
  achExceptionRulesEdit = 'Edit ACH Exception Rule',
  achExceptionRulesView = 'View ACH Exception Rule',
  viewAuditHistory = 'View Audit History',
  viewTransaction = 'View Transaction',
}

export enum menuUrls {
  home = '/home/menu',
  helpPageManagement = '/help-page-management',
  pageNotFound = '/page-not-found',
  accessDenied = '/access-denied',
  exceptionProcessing = '/exception-processing',
  quickExceptionProcessing = '/quick-exception-processing',
  adminDecisionProcessing = '/admin-decision-processing',
  submitIssuedCheckFile = '/submit-issued-check-file',
  addNewIssuedCheck = '/add-new-issued-check',
  allTransactions = '/all-transactions',
  searchResult = '/all-transactions/search-result',
  voidChecks = '/void-checks',
  achExceptionRules = '/ach-exception-rules',
  checkVerification = '/check-verification',
  bankUserSetup = '/bank-user-setup',
  editBankUserSetup = '/bank-user-setup/edit',
  securityTemplates = '/security-templates',
  broadcastEmail = '/broadcast-email',
  purgeTransactions = '/purge-transactions',
  systemWideRules = '/system-wide-rules',
  clientSetup = '/client-setup',
  viewClientSetup = '/client-setup/view',
  addClientSetup = '/client-setup/add',
  editClientSetup = '/client-setup/edit',
  accountSetup = '/account-setup',
  newAccount = '/account-setup/add',
  editAccount = '/account-setup/edit',
  viewAccount = '/account-setup/view',
  viewUsersForAccount = '/account-setup/users-for-account',
  clientUserSetup = '/client-user-setup',
  fileMappingSetup = '/file-mapping-setup',
  payeeMatchParameters = '/payee-match-parameter',
  addPayeeMatchParameters = '/payee-match-parameter/add',
  editPayeeMatchParameters = '/payee-match-parameter/edit',
  viewPayeeMatchParameters = '/payee-match-parameter/view',
  batchProcessing = '/batch-processing',
  dataImportProcessing = '/data-import-processing',
  fileMappingFormats = '/file-mapping-formats',
  sentEmailTexts = '/sent-email-text-log',
  sentEmailTextsResults = '/sent-email-text-log/results',
  auditTrailLog = '/audit-trail-log',
  loginAccessReport = '/login-access-report',
  systemAudit = '/system-audit',
  transactionAudit = '/transaction-audit',
  userAudit = '/user-audit',
  dailyChecksIssuedSummary = '/daily-checks-issued-summary',
  issuedCheckProcessingLog = '/check-file-upload-history',
  issuedCheckProcessingLogResults = '/check-file-upload-history-results',
  exceptionItems = '/exception-items',
  exceptionItemsSearchResult = '/exception-items/search-result',
  viewExceptionItem = '/exception-items/search-result/view',
  exceptionItemAuditHistory = '/exception-items/search-result/audit-history',
  managementDashboard = '/management-dashboard',
  reconciliationSummary = '/reconciliation-summary',
  brandingSetup = '/branding-setup',
  emailTextSetup = '/email-text-setup',
  exceptionCodes = '/exception-codes',
  holidayDates = '/holiday-dates',
  reasonCodes = '/reason-codes',
  systemAction = '/system-action',
  systemClassification = '/system-classification',
  systemErrors = '/system-errors',
  systemSetup = '/system-setup',
  transactionCodes = '/transaction-codes',
  preview = '/preview',
  addFileMapping = '/file-mapping-setup/add',
  viewFileMapping = '/file-mapping-setup/view',
  editFileMapping = '/file-mapping-setup/edit',
  copyFileMapping = '/file-mapping-setup/copy',
  userRoles = '/user-roles',
  viewUserRole = '/user-roles/view',
  addUserRole = '/user-roles/add',
  editUserRole = '/user-roles/edit',
  addClientUserSetup = '/client-user-setup/add',
  copyClientUserSetup = '/client-user-setup/copy',
  editClientUserSetup = '/client-user-setup/edit',
  addBankUserSetup = '/bank-user-setup/add',
  copyBankUserSetup = '/bank-user-setup/copy',
  helpPagePreview = '/help-page/preview',
  resultScreen = '/check-file-upload-history/result-screen',
  viewErrorDetail = '/check-file-upload-history/result-screen/view-error',
  achExceptionRulesAdd = '/ach-exception-rules/add',
  achExceptionRulesEdit = '/ach-exception-rules/edit',
  achExceptionRulesView = '/ach-exception-rules/view',
  viewAuditHistory = '/all-transactions/search-result/view-audit-history',
  viewTransaction = '/all-transactions/search-result/view',
}

export const createMapping = (enum1: Record<string, string>, enum2: Record<string, string>): Record<string, string> => {
  const mapping: Record<string, string> = {} as Record<string, string>
  for (const key in enum1) {
    if (Object.hasOwn(enum1, key)) {
      mapping[enum1[key]] = enum2[key]
    }
  }
  return mapping
}

export const UrlToPageNameMapping = createMapping(menuUrls, submenuItems)
